// Section 22 Jobs: the Auto-fill button proposes assignments that cover needs using current
// skills; the proposal is shown as a diff and applied only when the player presses Apply.
import type { AutoFillRow } from '../../viewModels';
import { oneDecimal } from '../format';
import { uiText } from '../text/en';

interface Props {
  rows: AutoFillRow[];
  open: boolean;
  canEdit: boolean;
  onPropose: () => void;
  onApply: () => void;
  onDiscard: () => void;
}

export function AutoFill({ rows, open, canEdit, onPropose, onApply, onDiscard }: Props) {
  const t = uiText.jobs;
  return (
    <section class="autofill" aria-labelledby="autofill-title">
      <div class="autofill__bar">
        <button type="button" class="button" disabled={!canEdit} onClick={onPropose}>
          {t.autoFill}
        </button>
        <span class="hint">{t.autoFillHint}</span>
      </div>
      {open && (
        <div class="autofill__diff">
          <h3 id="autofill-title">{t.autoFillTitle}</h3>
          <ul>
            {rows.map((r) => (
              <li key={r.personId}>
                {t.autoFillRow(r.name, r.fromLabel.toLowerCase(), r.toLabel.toLowerCase())}{' '}
                <span class="hint">
                  ({t.skill} <span class="num">{oneDecimal(r.skillFrom)}</span> →{' '}
                  <span class="num">{oneDecimal(r.skillTo)}</span>)
                </span>
              </li>
            ))}
          </ul>
          <div class="card__actions">
            <button type="button" class="button button--primary" onClick={onApply} data-autofocus>
              {t.apply}
            </button>
            <button type="button" class="button" onClick={onDiscard}>
              {t.discard}
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
